import Vue from 'vue'
import Router from 'vue-router'

// 路由级按需加载。原来 42 个页面全部同步 import，app.js 打到 2004KB（gzip 884KB），
// 其中 1366KB 是 279 张 base64 内联图 —— help.vue 和 cards.vue 贡献了大半，
// 而这两个页面绝大多数用户根本不会打开。
//
// 只留 Main 和首页 index 同步引入；其余按业务分组，webpackChunkName 相同的合成一包。
import Main from '@/components/Main'
import index from '@/components/mode/index'

// 登录/注册
const Login = () => import(/* webpackChunkName: "p-auth" */ '@/components/Login')
const Register = () => import(/* webpackChunkName: "p-auth" */ '@/components/Register')

// 各玩法大厅
const sports = () => import(/* webpackChunkName: "p-game" */ '@/components/mode/sports')
const lottery = () => import(/* webpackChunkName: "p-game" */ '@/components/mode/lottery')
const electronic = () => import(/* webpackChunkName: "p-game" */ '@/components/mode/electronic')
const people = () => import(/* webpackChunkName: "p-game" */ '@/components/mode/people')
const amusement = () => import(/* webpackChunkName: "p-game" */ '@/components/mode/amusement')
const amusementList = () => import(/* webpackChunkName: "p-game" */ '@/components/mode/amusementList')
const app = () => import(/* webpackChunkName: "p-game" */ '@/components/mode/app')

// 362KB，其中 38 张 base64 内联图，单独成块
const cards = () => import(/* webpackChunkName: "p-cards" */ '@/components/mode/cards')

// 629KB，107 张 base64 内联图，单独成块
const help = () => import(/* webpackChunkName: "p-help" */ '@/components/mode/help')

// 充值/提现/转账
const deposit = () => import(/* webpackChunkName: "p-pay" */ '@/components/mine/deposit')
const withdrawal = () => import(/* webpackChunkName: "p-pay" */ '@/components/mine/withdrawal')
const transfer = () => import(/* webpackChunkName: "p-pay" */ '@/components/mine/transfer')
const PayInfo = () => import(/* webpackChunkName: "p-pay" */ '@/components/PayInfo')
const rechargeResult = () => import(/* webpackChunkName: "p-pay" */ '@/components/rechargeResult')

// 个人中心
const mine = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/mine')
const userInfo = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/userInfo')
const password = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/password')
const contacts = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/contacts')
const bankCard = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/bankCard')
const myVip = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/myVip')
const boonCenter = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/boonCenter')
const mail = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/mail')
const welfare = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/welfare')
const perfunds = () => import(/* webpackChunkName: "p-mine" */ '@/components/mine/perfunds')

// 记录/申请
const transRecord = () => import(/* webpackChunkName: "p-record" */ '@/components/mine/transRecord')
const betRecord = () => import(/* webpackChunkName: "p-record" */ '@/components/mine/betRecord')
const apply = () => import(/* webpackChunkName: "p-record" */ '@/components/mine/apply')
const applyList = () => import(/* webpackChunkName: "p-record" */ '@/components/mine/applyList')

// 优惠/VIP/代理/赞助
const discount = () => import(/* webpackChunkName: "p-promo" */ '@/components/mode/discount')
const discountInfo = () => import(/* webpackChunkName: "p-promo" */ '@/components/mode/discountInfo')
const vipInfo = () => import(/* webpackChunkName: "p-promo" */ '@/components/mode/vipInfo')
const userredpacket = () => import(/* webpackChunkName: "p-promo" */ '@/components/userredpacket')
const agent = () => import(/* webpackChunkName: "p-promo" */ '@/components/agent')
const zhanzhu01 = () => import(/* webpackChunkName: "p-promo" */ '@/components/zanzhu/zhanzhu01')
const zhanzhu02 = () => import(/* webpackChunkName: "p-promo" */ '@/components/zanzhu/zhanzhu02')
const zhanzhu03 = () => import(/* webpackChunkName: "p-promo" */ '@/components/zanzhu/zhanzhu03')
const zhanzhu04 = () => import(/* webpackChunkName: "p-promo" */ '@/components/zanzhu/zhanzhu04')
const zhanzhu05 = () => import(/* webpackChunkName: "p-promo" */ '@/components/zanzhu/zhanzhu05')

Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/vipInfo',
          name: 'vipInfo',
          // meta: {
          //   requireAuth: true,
          // },
          component: vipInfo,

        }, {
          path: '/help',
          name: 'help',
          meta: {
            requireAuth: true,
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          },
          component: help,

        }, {
          path: '/discount',
          name: 'discount',
          // meta: {
          //   requireAuth: true,
          // },
          component: discount,

        }, {
          path: '/discountInfo',
          name: 'discountInfo',
          meta: {
            requireAuth: true,
          },
          component: discountInfo,

        }, {
          path: '/zhanzhu01',
          name: 'zhanzhu01',
          // meta: {
          //   requireAuth: true,
          // },
          component: zhanzhu01,
        }, {
          path: '/zhanzhu02',
          name: 'zhanzhu02',
          // meta: {
          //   requireAuth: true,
          // },
          component: zhanzhu02,
        }, {
          path: '/zhanzhu03',
          name: 'zhanzhu03',
          // meta: {
          //   requireAuth: true,
          // },
          component: zhanzhu03,
        }, {
          path: '/zhanzhu04',
          name: 'zhanzhu04',
          // meta: {
          //   requireAuth: true,
          // },
          component: zhanzhu04,
        }, {
          path: '/zhanzhu05',
          name: 'zhanzhu05',
          // meta: {
          //   requireAuth: true,
          // },
          component: zhanzhu05,
        }, {
          path: '/sports',
          name: 'sports',

          component: sports,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }
        , {
          path: '/lottery',
          name: 'lottery',

          component: lottery, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/electronic',
          name: 'electronic',

          component: electronic,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/people',
          name: 'people',

          component: people, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/cards',
          name: 'cards',

          component: cards,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/app',
          name: 'app',
          // meta: {
          //   requireAuth: true,
          // },
          component: app,
        }, {
          path: '/amusement',
          name: 'amusement',

          component: amusement,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/amusementList',
          name: 'amusementList',
          // meta: {
          //   requireAuth: true,
          // },
          component: amusementList,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }


      ]
    }
    ,
    {
      path: '/login',
      name: 'login',
      component: Login,
    }, {
      path: '/agent',
      name: 'agent',
      // meta: {
      //   requireAuth: true,
      // },
      component: agent,
    }, {
      path: '/userredpacket',
      name: 'userredpacket',
      // meta: {
      //   requireAuth: true,
      // },
      component: userredpacket,
    },
    {
      path: '/payInfo',
      name: 'payInfo',
      meta: {
        requireAuth: true,
      },
      component: PayInfo,
    },
    {
      path: '/rechargeResult',
      name: 'rechargeResult',
      component: rechargeResult,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/mine',
      name: 'mine',
      title: '个人中心',
      component: Main,
      children: [{
        path: '/mine/mine',
        name: 'mine',
        title: '个人中心父',
        meta: {
          requireAuth: true,
        },
        component: mine,
        children: [{
          path: '/mine/deposit',
          name: 'deposit',
          title: '存款',
          meta: {
            requireAuth: true,
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          },
          component: deposit,
        }, {
          path: '/mine/withdrawal',
          name: 'withdrawal',
          title: '取款',
          meta: {
            requireAuth: true,
          },
          component: withdrawal,
        }, {
          path: '/mine/transfer',
          name: 'transfer',
          title: '转账',
          meta: {
            requireAuth: true,
          },
          component: transfer,
        }, {
          path: '/mine/transRecord',
          name: 'transRecord',
          title: '交易记录',
          meta: {
            requireAuth: true,
          },
          component: transRecord,
        }, {
          path: '/mine/betRecord',
          name: 'betRecord',
          title: '投注记录',
          meta: {
            requireAuth: true,
          },
          component: betRecord,
        }, {
          path: '/mine/bankCard',
          name: 'bankCard',
          title: '银行卡',
          meta: {
            requireAuth: true,
          },
          component: bankCard,
        }, {
          path: '/mine/myVip',
          name: 'myVip',
          title: '账户中心',
          meta: {
            requireAuth: true,
          },
          component: myVip,
        }, {
          path: '/mine/boonCenter',
          name: 'boonCenter',
          title: '返水中心',
          meta: {
            requireAuth: true,
          },
          component: boonCenter,
        }, {
          path: '/mine/mail',
          name: 'mail',
          title: '消息公告',
          meta: {
            requireAuth: true,
          },
          component: mail,
        }, {
          path: '/mine/userInfo',
          name: 'userInfo',
          title: '个人资料',
          meta: {
            requireAuth: true,
          },
          component: userInfo,
        }, {
          path: '/mine/password',
          name: 'password',
          title: '密码修改',
          meta: {
            requireAuth: true,
          },
          component: password,
        }, {
          path: '/mine/contacts',
          name: 'contacts',
          title: '手机邮箱',
          meta: {
            requireAuth: true,
          },
          component: contacts,
        }, {
          path: '/mine/welfare',
          name: 'welfare',
          title: '红包',
          meta: {
            requireAuth: true,
          },
          component: welfare,
        }, {
          path: '/mine/perfunds',
          name: 'perfunds',
          title: '资金明细',
          meta: {
            requireAuth: true,
          },
          component: perfunds,
        }, {
          path: '/mine/apply',
          name: 'apply',
          title: '申请代理',
          meta: {
            requireAuth: true,
          },
          component: apply,
        }, {
          path: '/mine/applyList',
          name: 'applyList',
          title: '活动申请记录',
          meta: {
            requireAuth: true,
          },
          component: applyList,
        }
        ]
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js